import { all, takeEvery, select } from 'redux-saga/effects';
import { getDisableProductComparisons } from 'common/selectors';
import {
  PRODUCTS_COMPARE_MANAGE,
  PRODUCTS_COMPARE_LOAD_DATA,
  MANAGE_PRODUCT_IN_COMPARE_LIST,
  RETRY_LAST_COMPARE_ACTION,
} from '../actions';
import { fetchCompareListsSaga } from './fetch-compare-lists-saga';
import { fetchCompareDataSaga } from './fetch-compare-data-saga';
import { manageProductInCompareList } from './manage-product-in-compare-list';
import { retryLastActionSaga } from './user-actions-saga';

export function* productsCompareRootSaga() {
  const disableComparisons: boolean = yield select(getDisableProductComparisons);
  if (!disableComparisons) {
    yield all([
      takeEvery(PRODUCTS_COMPARE_MANAGE.request, fetchCompareListsSaga),
      takeEvery(PRODUCTS_COMPARE_LOAD_DATA.request, fetchCompareDataSaga),
      takeEvery(MANAGE_PRODUCT_IN_COMPARE_LIST, manageProductInCompareList),
      takeEvery(RETRY_LAST_COMPARE_ACTION, retryLastActionSaga),
    ]);
  }
}

export { fetchCompareListsSaga, fetchCompareDataSaga, manageProductInCompareList };
